import {
    MonitorSmartphone, Smartphone, Store, ShoppingCart, CalendarCheck, CreditCard,
    MessageCircle, Users, Clapperboard, Megaphone, MapPin, Palette, AppWindow,
    Bot, LayoutDashboard, UtensilsCrossed, Scissors, Stethoscope, Building2,
    GraduationCap, ShoppingBag, BedDouble, Factory, Plane, Globe, Zap, Cpu,
    TrendingUp, Sparkles, Rocket, SearchCheck, PenTool, Code2, FlaskConical,
    BadgeCheck, Headset, FileText, Image, Wrench, Share2,
} from "lucide-react";

export const CONTACT = {
    phoneDisplay: "8218551450",
    phoneTel: "tel:+918218551450",
    email: "animexaai2026@gmail.com",
    website: "animexa.in",
    location: "Dehradun, Uttarakhand, India",
    waBase: "https://wa.me/918218551450",
    waDefault:
        "https://wa.me/918218551450?text=" +
        encodeURIComponent(
            "Hello Animexa Tech Solutions, I would like to discuss a digital solution for my business."
        ),
};

export const NAV_LINKS = [
    { label: "Home", id: "#home" },
    { label: "Services", id: "#services" },
    { label: "Solutions", id: "#solutions" },
    { label: "Work", id: "#work" },
    { label: "About", id: "#about" },
    { label: "Pricing", id: "#pricing" },
    { label: "Contact", id: "#contact" },
];

export const TRUST_ITEMS = [
    { icon: MonitorSmartphone, title: "Website Development" },
    { icon: Smartphone, title: "Mobile Apps" },
    { icon: Store, title: "Business Digitization" },
    { icon: Cpu, title: "Automation" },
    { icon: Sparkles, title: "AI Solutions" },
    { icon: TrendingUp, title: "Digital Growth" },
];

export const MARQUEE_ITEMS = [
    "Websites", "Mobile Apps", "Automation", "AI Solutions", "E-Commerce",
    "WhatsApp Automation", "Digital Marketing", "Business Dashboards", "Branding",
];

export const SERVICES = [
    {
        icon: MonitorSmartphone,
        title: "Website Design & Development",
        desc: "Modern, responsive and professional websites designed to establish your business online and generate enquiries.",
        goodFor: "Any business that needs a credible, enquiry-generating online presence.",
        points: [
            "Custom design — no generic templates",
            "Mobile-first, responsive build",
            "Enquiry forms, WhatsApp & Google Maps integration",
            "Basic SEO setup for discoverability",
            "Launch support and handover",
        ],
    },
    {
        icon: Smartphone,
        title: "Mobile App Development",
        desc: "Business-focused mobile applications for Android and iOS use cases.",
        goodFor: "Businesses that need bookings, orders or services in their customers' pockets.",
        points: [
            "Android & iOS focused builds",
            "Business workflows — bookings, orders, enquiries",
            "Admin control for content and data",
            "Play Store / App Store launch guidance",
            "Post-launch support options",
        ],
    },
    {
        icon: Store,
        title: "Offline Business to Online",
        desc: "Transform traditional businesses into professional digital businesses with websites, Google presence, WhatsApp, booking and lead systems.",
        goodFor: "Shops, clinics, salons and local businesses taking the first digital step.",
        points: [
            "Professional business website",
            "Google Business Profile setup",
            "WhatsApp enquiry flow",
            "Booking / order capture",
            "Simple lead tracking system",
        ],
    },
    {
        icon: ShoppingCart,
        title: "E-commerce Development",
        desc: "Online stores with product catalogues, shopping cart, payments and customer workflows.",
        goodFor: "Retailers and manufacturers ready to sell beyond their physical location.",
        points: [
            "Product catalogue & categories",
            "Cart, checkout & order flow",
            "Payment gateway integration",
            "Order & customer management",
            "Offers and coupon support",
        ],
    },
    {
        icon: CalendarCheck,
        title: "Online Booking Systems",
        desc: "Appointment and booking systems for salons, clinics, consultants, hotels and service businesses.",
        goodFor: "Salons, clinics, consultants, hotels and appointment-driven services.",
        points: [
            "Service & time-slot booking",
            "Automated confirmations",
            "Reschedule & cancellation flow",
            "Staff / availability management",
            "Instant notifications on WhatsApp or email",
        ],
    },
    {
        icon: CreditCard,
        title: "Payment Integration",
        desc: "Integrate online payment solutions into websites and applications where required.",
        goodFor: "Businesses that want to accept UPI, cards or online payments professionally.",
        points: [
            "UPI, cards & net-banking via payment gateways",
            "Payment links & invoices",
            "Success / failure handling",
            "Transaction records",
            "Gateway onboarding guidance",
        ],
    },
    {
        icon: MessageCircle,
        title: "WhatsApp Business & Automation",
        desc: "Connect businesses with customers through WhatsApp enquiry flows, automated responses and lead workflows.",
        goodFor: "Any business whose customers already reach out on WhatsApp.",
        points: [
            "WhatsApp Business profile setup",
            "Auto-replies & quick replies",
            "Enquiry capture flows",
            "Product / service catalogue setup",
            "Broadcast & follow-up guidance",
        ],
    },
    {
        icon: Users,
        title: "CRM & Lead Management",
        desc: "Organize enquiries, customer information and sales follow-ups in a structured digital system.",
        goodFor: "Businesses losing track of enquiries across calls, chats and notebooks.",
        points: [
            "Central enquiry inbox",
            "Follow-up tracking & reminders",
            "Organized customer records",
            "Lead source tracking",
            "Team access & roles",
        ],
    },
    {
        icon: Clapperboard,
        title: "AI Video & Shorts Creation",
        desc: "AI-assisted creation of short-form videos for YouTube, Instagram and other social platforms.",
        goodFor: "Brands that want consistent short-form content without a studio.",
        points: [
            "Short-form video concepts",
            "AI-assisted production & editing",
            "YouTube Shorts / Instagram Reels formats",
            "Captions, hooks & brand style",
            "Platform-ready exports",
        ],
    },
    {
        icon: Megaphone,
        title: "Digital Marketing",
        desc: "Digital presence and marketing support designed around business goals.",
        goodFor: "Businesses ready to be discovered by more of the right customers.",
        points: [
            "Channel & campaign planning",
            "Content calendars",
            "Ad campaign support",
            "Local discovery focus",
            "Simple monthly reporting",
        ],
    },
    {
        icon: MapPin,
        title: "Google Business Profile",
        desc: "Help businesses establish and optimize their local Google presence.",
        goodFor: "Local businesses that want to be found on Google Search and Maps.",
        points: [
            "Profile creation / claim",
            "Category & service optimization",
            "Photos, posts & updates",
            "Review strategy",
            "Local ranking fundamentals",
        ],
    },
    {
        icon: Palette,
        title: "Branding & Graphic Design",
        desc: "Professional digital branding including business graphics, social media creatives and marketing materials.",
        goodFor: "New businesses building an identity, or existing ones refreshing it.",
        points: [
            "Logo & brand kit",
            "Social media creatives",
            "Visiting cards & marketing material",
            "Menus & brochures",
            "Consistent visual identity",
        ],
    },
    {
        icon: AppWindow,
        title: "Custom Web Applications",
        desc: "Custom dashboards, portals, customer systems and business applications.",
        goodFor: "Businesses whose workflows don't fit off-the-shelf software.",
        points: [
            "Dashboards & portals",
            "Customer / vendor systems",
            "Role-based access",
            "Integrations with your existing tools",
            "Scalable architecture",
        ],
    },
    {
        icon: Bot,
        title: "AI Automation Solutions",
        desc: "Use AI and automation to reduce repetitive work and improve business workflows.",
        goodFor: "Teams spending hours on repetitive, manual digital work.",
        points: [
            "Repetitive task automation",
            "AI chat & drafting assistants",
            "Document & data processing",
            "Workflow integrations",
            "Measurable time savings",
        ],
    },
    {
        icon: LayoutDashboard,
        title: "Business Dashboards & Admin Panels",
        desc: "Centralized dashboards for managing customers, bookings, orders, enquiries and business operations.",
        goodFor: "Owners who want one screen to see and run the whole business.",
        points: [
            "Sales & enquiry overview",
            "Bookings & orders management",
            "Content management",
            "Reports & exports",
            "Secure admin access",
        ],
    },
];

export const SOLUTIONS = [
    { icon: UtensilsCrossed, name: "Restaurant", includes: ["Website", "Digital Menu", "WhatsApp", "Online Enquiry"] },
    { icon: Scissors, name: "Salon", includes: ["Website", "Appointment Booking", "WhatsApp"] },
    { icon: Stethoscope, name: "Clinic", includes: ["Website", "Appointment System", "Patient Enquiry"] },
    { icon: Building2, name: "Real Estate", includes: ["Property Website", "Lead Management", "Enquiry System"] },
    { icon: GraduationCap, name: "Coaching Institute", includes: ["Website", "Admission Enquiry", "Student Information System"] },
    { icon: ShoppingBag, name: "Retail Business", includes: ["E-commerce", "Payments", "Customer Management"] },
    { icon: BedDouble, name: "Hotel", includes: ["Website", "Booking Enquiry", "WhatsApp"] },
    { icon: Factory, name: "Manufacturer", includes: ["Product Catalogue", "Enquiry System", "Business Website"] },
    { icon: Plane, name: "Travel Agency", includes: ["Website", "Tour Packages", "Enquiry / Booking"] },
];

export const OFFLINE_FLOW = [
    { icon: Store, label: "Offline Business" },
    { icon: PenTool, label: "Digital Branding" },
    { icon: Globe, label: "Website" },
    { icon: MapPin, label: "Google Business Profile" },
    { icon: MessageCircle, label: "WhatsApp" },
    { icon: Zap, label: "Online Enquiries" },
    { icon: CalendarCheck, label: "Bookings / Orders" },
    { icon: Users, label: "Lead Management" },
    { icon: TrendingUp, label: "Digital Growth" },
];

export const WHY_POINTS = [
    { icon: Bot, title: "AI-Assisted Development", desc: "Modern AI tooling accelerates delivery while keeping quality high." },
    { icon: Cpu, title: "Modern Technology", desc: "Current, proven web and mobile technology — not outdated stacks." },
    { icon: Smartphone, title: "Mobile-First Design", desc: "Every experience is designed for the phone first, then scaled up." },
    { icon: BadgeCheck, title: "Business-Focused Solutions", desc: "Technology chosen around your business goals, not trends." },
    { icon: Rocket, title: "Fast Development", desc: "Lean process and AI-assisted workflows keep timelines tight." },
    { icon: TrendingUp, title: "Scalable Systems", desc: "Start small, grow without rebuilding from scratch." },
    { icon: FileText, title: "Transparent Scope", desc: "Clear features, clear pricing basis, no hidden surprises." },
    { icon: Headset, title: "Personalized Support", desc: "Direct support from the person building your product." },
];

export const PROCESS_STEPS = [
    { icon: SearchCheck, title: "Understand", desc: "Understand your business and requirements." },
    { icon: FileText, title: "Plan", desc: "Define features, structure and technology." },
    { icon: PenTool, title: "Design", desc: "Create the visual experience and user flow." },
    { icon: Code2, title: "Build", desc: "Develop and integrate the required systems." },
    { icon: FlaskConical, title: "Test", desc: "Test responsiveness, functionality and usability." },
    { icon: Rocket, title: "Launch & Support", desc: "Deploy the project and provide agreed support." },
];

export const PRICING = [
    {
        name: "Starter",
        price: "₹7,999",
        features: [
            "Basic website",
            "Responsive design",
            "WhatsApp integration",
            "Contact / enquiry form",
            "Google Maps",
            "Basic SEO setup",
            "Basic support",
        ],
        popular: false,
    },
    {
        name: "Business",
        price: "₹14,999",
        features: [
            "5–7 page professional website",
            "WhatsApp integration",
            "Google Business setup / optimization",
            "Enquiry system",
            "Gallery",
            "Services / products section",
            "Basic SEO",
            "Business email setup guidance",
            "Support",
        ],
        popular: true,
    },
    {
        name: "Growth",
        price: "₹24,999",
        features: [
            "Professional website",
            "Booking system",
            "Payment integration",
            "Lead management",
            "Review system",
            "Social integration",
            "WhatsApp automation",
            "Analytics",
            "Extended support",
        ],
        popular: false,
    },
];

export const ADDONS = [
    { icon: FileText, name: "Extra Website Page", note: "Based on requirements" },
    { icon: PenTool, name: "Logo / Branding", note: "Based on requirements" },
    { icon: CalendarCheck, name: "Booking System", note: "Starting from scope" },
    { icon: CreditCard, name: "Payment Integration", note: "Starting from scope" },
    { icon: MessageCircle, name: "WhatsApp Automation", note: "Based on requirements" },
    { icon: Wrench, name: "Monthly Maintenance", note: "Monthly plans" },
    { icon: SearchCheck, name: "SEO Support", note: "Monthly plans" },
    { icon: Image, name: "Social Media Creative Support", note: "Based on requirements" },
];

export const PORTFOLIO = [
    { icon: UtensilsCrossed, name: "Restaurant Website", desc: "Digital menu, gallery, WhatsApp ordering enquiry.", tags: ["Website", "Menu", "WhatsApp"], accent: "gold" },
    { icon: Scissors, name: "Salon Booking Website", desc: "Services showcase with slot-based appointment booking.", tags: ["Booking", "Website"], accent: "blue" },
    { icon: Stethoscope, name: "Clinic Website", desc: "Doctor profiles, appointment system, patient enquiry.", tags: ["Appointments", "Enquiry"], accent: "blue" },
    { icon: Building2, name: "Real Estate Website", desc: "Property listings with lead capture and enquiry flow.", tags: ["Listings", "Leads"], accent: "gold" },
    { icon: ShoppingBag, name: "E-commerce Store", desc: "Catalogue, cart, payments and order management.", tags: ["Store", "Payments"], accent: "blue" },
    { icon: GraduationCap, name: "Coaching Institute Website", desc: "Courses, admission enquiry and student information.", tags: ["Admissions", "Website"], accent: "gold" },
    { icon: LayoutDashboard, name: "Business Dashboard", desc: "Central panel for enquiries, orders and reports.", tags: ["Dashboard", "Admin"], accent: "blue" },
    { icon: AppWindow, name: "Custom Web Application", desc: "A tailored portal built around a unique workflow.", tags: ["Web App", "Portal"], accent: "gold" },
];

export const FAQS = [
    {
        q: "How much does a website cost?",
        a: "Website projects start from ₹7,999. Final pricing depends on pages, features, integrations and project requirements.",
    },
    {
        q: "How long does website development take?",
        a: "Timeline depends on project scope. Simple websites can be completed faster than custom systems or applications.",
    },
    {
        q: "Do you build mobile apps?",
        a: "Yes. We can develop business-focused mobile applications based on the required features and platform.",
    },
    {
        q: "Can you convert my offline business to online?",
        a: "Yes. We can create a digital presence including website, Google Business Profile, WhatsApp, enquiries, booking and other required systems.",
    },
    {
        q: "Do you provide maintenance?",
        a: "Yes. Maintenance and ongoing support can be provided through monthly plans.",
    },
    {
        q: "Can you integrate payments?",
        a: "Yes, payment integration can be included where supported and appropriate for the business.",
    },
    {
        q: "Can you build custom web applications?",
        a: "Yes. Custom dashboards, portals, CRM-style systems and other business applications can be developed based on requirements.",
    },
];

export const BUSINESS_TYPES = [
    "Retail / Shop", "Restaurant", "Hotel", "Salon", "Gym", "Clinic",
    "Coaching Institute", "Real Estate", "Travel Agency", "Manufacturer",
    "Service Provider", "Startup", "Other",
];

export const SERVICE_OPTIONS = [
    ...SERVICES.map((s) => s.title),
    "Complete Offline-to-Online Package",
    "Not sure — need guidance",
];

export const DEMO_DETAILS = {
    "Restaurant Website": {
        url: "demo.animexa.in/restaurant",
        nav: ["Home", "Menu", "Gallery", "Contact"],
        hero: {
            badge: "Pure Veg & Non-Veg · Dehradun",
            title: "Annapurna Kitchen",
            sub: "Authentic flavours of Uttarakhand, now a tap away. Browse the menu and order directly on WhatsApp.",
            cta: "Order on WhatsApp",
        },
        blocks: [
            {
                type: "cards",
                heading: "Digital Menu",
                items: [
                    { title: "Butter Chicken", line: "Rich makhani gravy, tandoor spices", price: "₹280" },
                    { title: "Paneer Tikka", line: "Char-grilled cottage cheese", price: "₹220" },
                    { title: "Chicken Biryani", line: "Slow-cooked, dum style", price: "₹260" },
                    { title: "Masala Dosa", line: "Crisp, with podi & sambar", price: "₹140" },
                ],
            },
            { type: "form", heading: "Reserve a Table", fields: ["Your name", "Mobile number", "Guests & preferred time"], cta: "Send Enquiry" },
        ],
    },
    "Salon Booking Website": {
        url: "demo.animexa.in/salon",
        nav: ["Home", "Services", "Book", "Contact"],
        hero: {
            badge: "Unisex Salon · Dehradun",
            title: "Glow Studio",
            sub: "Book your slot online — no waiting, no phone tag. Instant confirmation on WhatsApp.",
            cta: "Book Appointment",
        },
        blocks: [
            {
                type: "cards",
                heading: "Services & Pricing",
                items: [
                    { title: "Haircut & Styling", line: "45 min · with wash", price: "₹299" },
                    { title: "Luxury Facial", line: "60 min · all skin types", price: "₹799" },
                    { title: "Hair Spa", line: "50 min · repair therapy", price: "₹1,499" },
                    { title: "Bridal Package", line: "Full-day · by consultation", price: "₹9,999" },
                ],
            },
            { type: "slots", heading: "Pick a Slot", days: ["Today", "Tomorrow", "Sunday"], times: ["10:00 AM", "11:30 AM", "1:00 PM", "3:30 PM", "5:00 PM", "6:30 PM"] },
        ],
    },
    "Clinic Website": {
        url: "demo.animexa.in/clinic",
        nav: ["Home", "Doctors", "Appointments", "Contact"],
        hero: {
            badge: "Multi-speciality Clinic · Dehradun",
            title: "CareWell Clinic",
            sub: "Book appointments online and reach the right doctor faster — with patient enquiry built in.",
            cta: "Book Appointment",
        },
        blocks: [
            {
                type: "list",
                heading: "Our Doctors",
                items: [
                    { title: "Dr. A. Mehra", line: "General Physician", tag: "Mon–Sat" },
                    { title: "Dr. S. Nautiyal", line: "Dental Care", tag: "Tue–Sun" },
                    { title: "Dr. R. Bisht", line: "Physiotherapy", tag: "By appointment" },
                ],
            },
            { type: "slots", heading: "Available Today", days: ["Morning", "Afternoon", "Evening"], times: ["9:30 AM", "11:00 AM", "12:30 PM", "4:00 PM", "5:30 PM", "7:00 PM"] },
            { type: "form", heading: "Patient Enquiry", fields: ["Patient name", "Mobile number", "Health concern"], cta: "Request Callback" },
        ],
    },
    "Real Estate Website": {
        url: "demo.animexa.in/properties",
        nav: ["Home", "Properties", "About", "Contact"],
        hero: {
            badge: "Dehradun Property Experts",
            title: "HillView Properties",
            sub: "Verified listings with direct enquiry — every lead lands in your phone, organized.",
            cta: "Enquire Now",
        },
        blocks: [
            {
                type: "cards",
                heading: "Featured Properties",
                items: [
                    { title: "2 BHK Apartment", line: "Rajpur Road · 1,050 sq.ft", price: "₹58 L" },
                    { title: "3 BHK Villa", line: "Sahastradhara Road · garden", price: "₹82 L" },
                    { title: "Commercial Shop", line: "Paltan Bazaar · corner", price: "₹1.2 Cr" },
                    { title: "1 BHK Studio", line: "Clement Town · furnished", price: "₹32 L" },
                ],
            },
            { type: "form", heading: "Request a Site Visit", fields: ["Your name", "Mobile number", "Property of interest"], cta: "Get Details on WhatsApp" },
        ],
    },
    "E-commerce Store": {
        url: "demo.animexa.in/store",
        nav: ["Home", "Shop", "Orders", "Contact"],
        hero: {
            badge: "Himalayan Handmade · Ships Across India",
            title: "Pahadi Haat",
            sub: "Local crafts and organic products with cart, payments and order tracking built in.",
            cta: "Shop Now",
        },
        blocks: [
            {
                type: "cards",
                heading: "Best Sellers",
                items: [
                    { title: "Handcrafted Soy Candle", line: "Cedar & pine · 40 hr burn", price: "₹499" },
                    { title: "Organic Hill Honey", line: "Raw · 500 g jar", price: "₹349" },
                    { title: "Woollen Shawl", line: "Handwoven · pure wool", price: "₹1,299" },
                    { title: "Buransh Squash", line: "Rhododendron · 750 ml", price: "₹299" },
                ],
            },
            {
                type: "list",
                heading: "Why Shop With Us",
                items: [
                    { title: "Free shipping", line: "On all orders above ₹999", tag: "Auto-applied" },
                    { title: "Cash on Delivery", line: "Available across India", tag: "COD" },
                    { title: "Easy Returns", line: "7-day return window", tag: "No questions" },
                ],
            },
        ],
    },
    "Coaching Institute Website": {
        url: "demo.animexa.in/academy",
        nav: ["Home", "Courses", "Faculty", "Admissions"],
        hero: {
            badge: "Admissions Open 2026–27",
            title: "BrightFuture Academy",
            sub: "Result-focused coaching for Classes 9–12, NEET and JEE — with online admission enquiry.",
            cta: "Apply for Admission",
        },
        blocks: [
            {
                type: "list",
                heading: "Popular Courses",
                items: [
                    { title: "Class 11–12 Science", line: "PCM / PCB · daily batches", tag: "New Batch" },
                    { title: "NEET Crash Course", line: "6 months · test series", tag: "Limited Seats" },
                    { title: "JEE Foundation", line: "Class 9–10 · weekend", tag: "Weekend" },
                ],
            },
            { type: "form", heading: "Admission Enquiry", fields: ["Student name", "Parent mobile number", "Course interested in"], cta: "Request Callback" },
        ],
    },
    "Business Dashboard": {
        url: "demo.animexa.in/dashboard",
        nav: ["Overview", "Enquiries", "Orders", "Reports"],
        hero: {
            badge: "Sample Admin Panel",
            title: "Business Dashboard",
            sub: "One screen to track enquiries, bookings, orders and revenue — sample data shown.",
            cta: "See How It Works",
        },
        blocks: [
            {
                type: "stats",
                items: [
                    { label: "Enquiries Today", value: "12" },
                    { label: "Bookings", value: "8" },
                    { label: "Orders", value: "23" },
                    { label: "Revenue", value: "₹18,450" },
                ],
            },
            { type: "bars", heading: "Enquiries This Week", items: [45, 65, 50, 80, 70, 95, 60], labels: ["M", "T", "W", "T", "F", "S", "S"] },
            {
                type: "list",
                heading: "Recent Enquiries",
                items: [
                    { title: "Ramesh K.", line: "Website enquiry · 10:24 AM", tag: "New" },
                    { title: "Sunita D.", line: "Table booking · 9:50 AM", tag: "Confirmed" },
                    { title: "Amit S.", line: "Bulk order · Yesterday", tag: "Follow-up" },
                ],
            },
        ],
    },
    "Custom Web Application": {
        url: "demo.animexa.in/portal",
        nav: ["Dashboard", "Modules", "Team", "Settings"],
        hero: {
            badge: "Sample Internal Portal",
            title: "VendorHub Portal",
            sub: "A custom web application built around your exact workflow — sample data shown.",
            cta: "Discuss a Custom Build",
        },
        blocks: [
            {
                type: "cards",
                heading: "Modules",
                items: [
                    { title: "Inventory Management", line: "Stock levels & alerts" },
                    { title: "GST Invoicing", line: "Generate & download" },
                    { title: "Staff Attendance", line: "Shifts & leave tracking" },
                    { title: "Report Exports", line: "PDF / Excel in one click" },
                ],
            },
            { type: "bars", heading: "Purchase Orders per Month", items: [55, 70, 60, 85, 75, 90, 80], labels: ["J", "F", "M", "A", "M", "J", "J"] },
        ],
    },
};
